import script from "./UserPii.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPii.vue?vue&type=script&setup=true&lang=js"

import "./UserPii.vue?vue&type=style&index=0&id=5b6d7c4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6d7c4c"]])

export default __exports__